import Header from './Header';
import Element from './Element';

function Piano() {
    return (
        <div>
            <div className="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <div className="box">
                    <h1 className="nonimage-h1">ピアノ伴奏</h1>
                    <p>いままでに作成したピアノの伴奏を掲載しています。</p>
                    <div className="items">
                        <p><span>Piano</span><span>Studio One</span></p>
                    </div>
                </div>
                <div className="content">
                    {Element("", "不思議", "作詞・作曲・編曲: 星野源", "https://nana-music.com/sounds/061ee641", true)}
                    {Element("", "きらり", "作詞・作曲・編曲: 藤井風", "https://nana-music.com/sounds/061df5d2", true)}
                    {Element("", "ノーチラス", "作詞・作曲・編曲: n-buna", "https://nana-music.com/sounds/06123b02", true)}
                    {Element("", "感電", "作詞・作曲・編曲: 米津玄師", "https://nana-music.com/sounds/060edab6", true)}
                    {Element("", "怪物", "作詞・作曲・編曲: Ayase", "https://nana-music.com/sounds/05f8a909", true)}
                    {Element("", "ルーム No.4", "作詞・作曲・編曲: すりぃ", "https://nana-music.com/sounds/05e9ed47", true)}
                </div>
            </div>
        </div>
    )
}

export default Piano;